import { render, staticRenderFns } from "./DishOrder.vue?vue&type=template&id=085b672b"
import script from "./DishOrder.vue?vue&type=script&lang=js"
export * from "./DishOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports